export default "__VITE_ASSET__By44FZ_W__"